import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import FormControl from '@mui/material/FormControl';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import CustomSelect from "../CustomComponents/CustomSelect";
import InputLabel from "@mui/material/InputLabel";
import Checkbox from '@mui/material/Checkbox';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import MomentUtils from "@date-io/moment";
import WeekPicker from "../../TimesheetItems/WeekPicker";
import moment from "moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { DatePicker } from "@material-ui/pickers";
import { MuiThemeProvider } from '@material-ui/core/styles'
import { muiThemeDesign } from '../../mui-theme-design';
import { muiThemePicker } from '../../mui-theme-design';
import MUIDataTable from 'mui-datatables';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
import { Link } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import Tooltip from '@mui/material/Tooltip';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import CloseFullscreenIcon from '@mui/icons-material/CloseFullscreen';

const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowY: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },
    scrollContainer: {
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexDirection: 'column',
  },

}));


const getMuiTheme = () =>
  createTheme({
    components: {
      MUIDataTableToolbar: {
        styleOverrides: {
          root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 16px',
            position: 'sticky',
            top: 0,
            backgroundColor: '#fff',
            zIndex: 130,
            borderBottom: '1px solid #e0e0e0',
          },
        },
      },
      MUIDataTableHeadCell: {
        styleOverrides: {
          root: {
            position: 'sticky',
            top: 56, // match toolbar height
            backgroundColor: '#fff',
            zIndex: 120,
          },
        },
      },
    },
  });
  
export default function ReportPayroll () {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [day, setDay] = React.useState(moment(new Date()).add(-14, 'd').weekday(0));
    const [dataSet, setDataSet] = React.useState([]);
    const [openLogs, setOpenLogs] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [fullScreen, setFullScreen] = React.useState(false);
    //const [POChoices, setPOChoices] = React.useState([]);
    const classes = pageStyles();
    const handleWeekCallback = (childData) => {
        logger('setDay', childData.format('YYYY-MM-DD'))
        setDay(childData.format('YYYY-MM-DD'));
    };

    const initialValues = {
        POID: ''
    };
    
    const validFormSchema = Yup.object({
        POID: Yup
            .string('Select a PO')
            .required('PO selection Required'),
            
    })
    /*const onTrigger = React.useCallback((values) => {
        const msg = {
        	  POID: values.POID,
            Name: values.POName,
            EffectiveDate: moment(values.effective),
        };
        logger("Trigger PO " + msg.POID)
        logger("Trigger Date " + msg.EffectiveDate)
     //   handleBillingPOCallback(msg);
        handleClose();
    })*/

    /*const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setPOChoices(choices)
    }*/

    React.useEffect(() => {
		checkAuthentication();
    //	logger("In UseEffect")
        if (refresh) {
             /*fetch('/api/PO/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));*/
            setRefresh(false);
        }
    })

    const handleGenerate = () => {
        logger(`/api/Reports/Payroll/${moment(day).format('YYYY-MM-DD')}/${moment(day).add(13, 'd').format('YYYY-MM-DD')}`)
        fetch(`/api/Reports/Payroll/${moment(day).format('YYYY-MM-DD')}/${moment(day).add(13, 'd').format('YYYY-MM-DD')}`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(json => {
                logger('output', json)
                setDataSet(json)
                setIsLoading(false);
            })
        setOpenLogs(true);
    };

    const handleClickOpen = () => {
        setRefresh(true)
        setOpen(true)
    };   
    /*const handleDay = (childData) => {
        setDay(childData);
        logger ("Day loaded -" +  day )
        setRefresh(false)
      }*/
    const handleClose = () => {
     //   setPOChoices(0);
        setOpen(false);
    };

    const handleOpenForLogs = () => {
        setOpenLogs(true)
    };

    const handleCloseForLogs = () => {
        setOpenLogs(false);
        setFullScreen(false);
        setFullScreen(false);
    }; 
    
    const handleMinimize = () => {
		setFullScreen(false);
	};
	
	const handleMaximize = () => {
	setFullScreen(true);
	};

    const columns = [
        {
            name: "BCI",
            label: "BCI",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "LastName",
            label: "LastName",
            options: {
                filter: true,
                sort: true,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={(`${dataSet[dataIndex].VerifyStatus}`.includes('-1') || `${dataSet[dataIndex].VerifyStatus}`.includes('0')) ? { color: "red" } : {}}>
                            {dataSet[dataIndex].LastName}
                        </div>
                    );
                }
            }
        },
        {
            name: "FirstName",
            label: "FirstName",
            options: {
                filter: true,
                sort: true,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={(`${dataSet[dataIndex].VerifyStatus}`.includes('-1') || `${dataSet[dataIndex].VerifyStatus}`.includes('0')) ? { color: "red" } : {}}>
                            {dataSet[dataIndex].FirstName}
                        </div>
                    );
                }
            }
        },
        {
            name: "Reg",
            label: "  Reg  ",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "OT",
            label: "  OT  ",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "TotalWorked",
            label: "TotalWorked",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "PTO",
            label: "PTO",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "HOLFloating",
            label: "HOLFloating",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Holiday",
            label: "Holiday",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Bereavement",
            label: "Bereavement",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Furlough",
            label: "Furlough",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Unpaid",
            label: "Unpaid",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Lunch",
            label: "Lunch",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "Total",
            label: "Total",
            options: {
                filter: true,
                sort: true,
            }
        }
    ];
    
    const getSavedRowsPerPage = () => {
		const savedValue = localStorage.getItem('rowsPerPage');
		return savedValue ? parseInt(savedValue) : 100; // Default value
	}

const MakeToolbar = () => {
		return (
			<>
				<Button component={Link} color="inherit" to="/Summary">Go to Summary</Button>
			</>
		);
		logger("createTB" + MakeToolbar)
	}
	const initialRowsPerPage = getSavedRowsPerPage();
	
    const baseOptions = {
        filter: true,
		filterType: 'dropdown',
		responsive: 'standard',
		fixedHeader: true,
		fixedSelectColumn: false,
		rowsPerPage: initialRowsPerPage,
		tableBodyHeight: "auto",
        tableBodyMaxHeight: "auto",
		rowsPerPageOptions: [10, 20, 50, 100],
		customToolbar: () => <MakeToolbar />,
		textLabels: {
			toolbar: {
				search: "Search",
				downloadCsv: "Download Excel",
				print: "Print",
				viewColumns: "View Columns",
				filterTable: "Filter Table",
			},
		},
		selectableRows: 'none',
		  onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				logger("headers", headers);
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			
			var add_date = true;
			var columnIndexToRemove = null;
			var numberOfColumnsToRemove = null;
			var filename = 'Payroll.xlsx';
			
			if (columnIndexToRemove !== null) {
				if (numberOfColumnsToRemove !== null) {
					headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
				} else {
					headers.splice(columnIndexToRemove, 1);
				}
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Sheet 1');
		
			const headerRow = worksheet.addRow(headers);
			headerRow.font = { bold: true };
		
			rows.forEach((row, rowIndex) => {
			    const newRow = worksheet.addRow(Object.values(row));
			    logger("newRow", newRow);
			
			    worksheet.columns.forEach((col, colIndex) => {
			        const headerLength = col.header ? col.header.length : 0; // Handle header if undefined
			        var maxColumnWidth = col.values.reduce((maxWidth, value) => {
			            if (value && value.length > maxWidth) {
			                return value.length;
			            }
			            return maxWidth;
			        }, 0);
			
			        if (maxColumnWidth > 40) {
			            maxColumnWidth = 40;
			        }
					col.width = Math.max(headerLength, maxColumnWidth) + 2;
					col.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
					if (dataSet[rowIndex]) {
						if ((colIndex === 1 || colIndex === 2) && (dataSet[rowIndex].VerifyStatus?.includes('-1') || dataSet[rowIndex].VerifyStatus?.includes('0'))) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
				});
			});
		
			const currentDate = moment.utc().format("yyyy-MM-DD");
			// Generate the Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
					: (filename || 'datatable.xlsx');
				a.click();
			});
			
			return false;
		}

};

	var options = {};
	if (!fullScreen) {
		options = {
			...baseOptions,
			tableBodyHeight: "450px",
			tableBodyMaxHeight: "1000px",
			responsive: 'standard',
		}
	} else {
		options = {
			...baseOptions,
			responsive: 'standard',
			tableBodyHeight: "800px",
			tableBodyMaxHeight: "84vh",
			rowsPerPage: initialRowsPerPage,
			selectableRows: 'none',
		}
	}

	options.onChangeRowsPerPage = (newRowsPerPage) => {
		saveRowsPerPage(newRowsPerPage);
	};
 
    return (
        <div>
        <MuiThemeProvider theme={muiThemeDesign}>
            <Button variant="contained" onClick={handleClickOpen}>
                Payroll Report
            </Button>
             <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            //onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                           edge="start"
                                           color="inherit"
                                           onClick={handleClose}
                                           aria-label="close"
                                        >
                                          <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Payroll Report
                                        </Typography>
                                            <Button color="inherit" onClick={handleGenerate}>
                                            Generate
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                    <DialogTitle>Payroll Report:</DialogTitle>            
                                 <div>
                                 {/*<FormControl  sx={{ m: 1, width: 220 }}>
										  <InputLabel htmlFor="POSelection">PO Name</InputLabel>
										  <CustomSelect
											name="POID"
											id="outlined-POSelection"
											options={POChoices}
											onChange={props.handleChange}
										//	onBlur={props.handleBlur}
											value={props.values.POID}
											error={props.touched.POID && Boolean(props.errors.POID)}
											helperText={props.touched.POID && props.errors.POID}
											label="POID"
																		/>
								  </FormControl>*/}
                                </div>
								     	<div sx={{paddingTop: {xs:10, sm:10, md: 10, lg:0, xl: 0}}} > 
									       <MuiPickersUtilsProvider utils={MomentUtils} locale="en">
                                            <div>

                                                <Grid item xs={2}>  <MuiThemeProvider theme={muiThemePicker}> <WeekPicker handleWeekCallback={handleWeekCallback} week={day} /></MuiThemeProvider></Grid>
                                                  
									         </div>
                                        </MuiPickersUtilsProvider>
                                        {/*stert:{moment(day)} end:{moment(day).add(13, 'd')}*/}
									    </div>
                            </Form>
                        )}
                        </Formik>
                        <Dialog
							open={openLogs}
							onClose={handleCloseForLogs}
							fullScreen={fullScreen}
							fullWidth
							maxWidth={fullScreen ? false : 'xl'}
							scroll="paper"
							PaperProps={{
								style: {
									height: fullScreen ? '100vh' : '70vh',
									margin: fullScreen ? 0 : '5vh auto',
									borderRadius: fullScreen ? 0 : 10,
									overflow: 'hidden',
									display: 'flex',
									flexDirection: 'column',
								}
							}}
						>
						<DialogContent
								sx={{
									p: 0,
									flex: 1,
									display: 'flex',
									flexDirection: 'column',
									overflow: 'hidden',
								}}
							>
								<Box
									sx={{
										flex: 1,
										overflowY: 'auto',
										overflowX: 'hidden',
										position: 'relative', 
									}}
								>
									<ThemeProvider theme={getMuiTheme()}>
										<MUIDataTable
											title={
												<Box
													sx={{
														display: 'flex',
														alignItems: 'center',
														bgcolor: '#1976d2',
														color: 'white',
														px: 2,
														py: 1,
													}}
												>
													<IconButton edge="start" color="inherit" onClick={handleCloseForLogs} aria-label="close"> <CloseIcon /> </IconButton>
													<Tooltip title={fullScreen ? 'Minimize' : 'Maximize'}>
														<IconButton
															color="inherit"
															onClick={fullScreen ? handleMinimize : handleMaximize}
														>
															{fullScreen ? <CloseFullscreenIcon /> : <FullscreenIcon />}
														</IconButton>
													</Tooltip>
													<Typography variant="h6" sx={{ flexGrow: 1, ml: 1 }}>
														Payroll Report ({moment(day).format('MM-DD-YYYY')} TO {moment(day).add(13, 'd').format('MM-DD-YYYY')})
													</Typography>
												</Box>
											}
											data={isLoading ? [] : dataSet}
											columns={columns}
											options={muiLoaderOptions(options, isLoading)}
										/>
									</ThemeProvider>
	                                </Box>
                            </DialogContent>
                        </Dialog>
                </DialogContent>                
            </Dialog>
            </MuiThemeProvider>
        </div>
    );
}
 